module.exports = __webpack_public_path__ + "static/media/Products 3.7302fca8.svg";